import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth, ROLE_LABELS } from '../context/AuthContext';
import {
  HiOutlineViewGrid,
  HiOutlineCube,
  HiOutlineClipboardList,
  HiOutlineUserGroup,
  HiOutlineCurrencyDollar,
  HiOutlineChartBar,
  HiOutlineCog,
  HiOutlineLogout,
  HiOutlineMenu,
  HiOutlineX,
  HiOutlineTruck,
  HiOutlineCash,
  HiOutlineDocumentDuplicate,
  HiOutlineShieldCheck,
} from 'react-icons/hi';
import './Layout.css';

const Layout = () => {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Menú según rol
  const menuItems = [
    {
      path: '/',
      icon: <HiOutlineViewGrid />,
      label: 'Dashboard',
      roles: ['admin', 'manager', 'salesman', 'warehouse', 'delivery', 'cashier', 'accountant'],
    },
    {
      path: '/ordenes',
      icon: <HiOutlineClipboardList />,
      label: 'Órdenes',
      roles: ['admin', 'manager', 'salesman', 'warehouse', 'cashier'],
    },
    {
      path: '/inventario',
      icon: <HiOutlineCube />,
      label: 'Inventario',
      roles: ['admin', 'manager', 'warehouse'],
    },
    {
      path: '/despacho',
      icon: <HiOutlineTruck />,
      label: 'Despacho',
      roles: ['admin', 'delivery', 'warehouse'],
    },
    {
      path: '/clientes',
      icon: <HiOutlineUserGroup />,
      label: 'Clientes',
      roles: ['admin', 'manager', 'salesman'],
    },
    {
      path: '/comisiones',
      icon: <HiOutlineCurrencyDollar />,
      label: 'Comisiones',
      roles: ['admin', 'manager', 'accountant', 'salesman'],
    },
    {
      path: '/gastos',
      icon: <HiOutlineCash />,
      label: 'Gastos',
      roles: ['admin', 'manager', 'accountant'],
    },
    {
      path: '/notas-credito',
      icon: <HiOutlineDocumentDuplicate />,
      label: 'Notas Crédito',
      roles: ['admin', 'manager', 'accountant'],
    },
    {
      path: '/reportes',
      icon: <HiOutlineChartBar />,
      label: 'Reportes',
      roles: ['admin', 'manager', 'accountant'],
    },
    {
      path: '/usuarios',
      icon: <HiOutlineCog />,
      label: 'Usuarios',
      roles: ['admin'],
    },
    {
      path: '/admin',
      icon: <HiOutlineShieldCheck />,
      label: 'Administración',
      roles: ['admin'],
    },
  ];

  const visibleItems = menuItems.filter((item) =>
    item.roles.some((role) => hasRole(role))
  );

  return (
    <div className="layout">
      {/* Overlay móvil */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src="/logo.png" alt="Surtidora M&T" className="sidebar-logo" />
          <div className="sidebar-brand">
            <h2>Surtidora M&T</h2>
            <span className="sidebar-version">v2.0</span>
          </div>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            <HiOutlineX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {visibleItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="user-avatar">
              {user?.full_name?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <div className="user-info">
              <span className="user-name">{user?.full_name || 'Usuario'}</span>
              <span className="user-role">{ROLE_LABELS[user?.role] || user?.role}</span>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout} title="Cerrar sesión">
            <HiOutlineLogout />
          </button>
        </div>
      </aside>

      {/* Contenido principal */}
      <div className="main-content">
        <header className="topbar">
          <button className="menu-toggle" onClick={() => setSidebarOpen(true)}>
            <HiOutlineMenu />
          </button>
          <div className="topbar-right">
            <div className="topbar-status">
              <span className="status-dot-green"></span>
              En línea
            </div>
          </div>
        </header>

        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
